import * as Sentry from "@sentry/browser";
import moment from "moment";
import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import styled from "styled-components";
import {
  BookingMessage,
  Chat,
  displayPrice,
  Event,
  Inquiry
} from "sweet-global";
import { colors } from "sweet-web/lib/styles";
import { RootState } from "sweet-web/redux";
import * as selectors from "sweet-web/redux/selectors";

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 25px 0;
  width: 100%;
`;

const Text = styled.p`
  color: ${colors.darkGray};
  background-color: ${colors.nearWhite};
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 500;
  margin: 0 20px;
  text-align: center;
`;

const Colored = styled.span`
  color: ${colors.primary};
`;

type OwnProps = {
  chat: Chat;
  message: BookingMessage;
};
type Props = OwnProps & ConnectedProps<typeof connector>;
const BookingMessageComponent: React.FC<Props> = props => {
  const { message, venue, chatUserName, userType, booking } = props;

  if (!message) return null;

  let text: string | any[] = "";

  let inquiry: Inquiry = null;
  let event: Event = null;

  console.log(message);

  switch (message.subType) {
    case "INQUIRY":
      inquiry = message.inquiry;
      text = `New inquiry for ${inquiry.guests} guests on ${moment(
        inquiry.date
      ).format("ddd MMM D")} at ${moment(inquiry.startTime, "HH:mm").format(
        "h:mm A"
      )} for ${inquiry.length} hrs`;
      break;
    case "PROPOSAL":
      event = message.event;
      text = `New proposal for ${event.guests} guests on ${moment(
        event.date
      ).format("ddd MMM D")} at ${moment(event.startTime, "HH:mm").format(
        "h:mm A"
      )} for ${event.length} hrs – ${displayPrice(event.deposit)} deposit, ${
        userType === "USER"
          ? displayPrice(event.total)
          : displayPrice(event.rental)
      } total`;
      break;
    case "CONFIRMATION":
      event = message.event;
      text = `Proposal confirmed at ${displayPrice(
        event.total
      )} total with ${displayPrice(event.deposit)} deposit`;
      break;
    case "REVISION":
      // TODO
      break;
    case "CANCELLATION":
      event = message.event;
      if (userType === "USER" && event.canceledBy === "USER") {
        text = `You cancelled the booking`;
      } else if (userType === "USER" && event.canceledBy === "VENUE") {
        text = `${venue.name} cancelled the booking`;
      } else if (userType === "VENUE" && event.canceledBy === "USER") {
        text = `You cancelled the booking`;
      } else if (userType === "VENUE" && event.canceledBy === "VENUE") {
        text = `${chatUserName} cancelled the booking`;
      }
      break;
    case "PAYMENT":
      if (booking.status === "INQUIRY") return;
      switch (message.payment.type) {
        case "DEPOSIT":
          text = `Successful deposit of ${displayPrice(booking.deposit)}`;
          break;
        case "PAYMENT":
          text =
            userType === "VENUE"
              ? `Received payment of ${displayPrice(booking.rental)}`
              : `Successful payment of ${displayPrice(booking.total)}`;
          break;
      }
      break;
  }

  return (
    <Wrapper>
      <Text>{text}</Text>
    </Wrapper>
  );
};

const mapState = (state: RootState, ownProps: OwnProps) => ({
  venue: selectors.getVenue(ownProps.chat.venue)(state),
  chatUserName: selectors.otherChatUserName(ownProps.chat.id)(state),
  booking: selectors.getBookingByChat(ownProps.chat.id)(state),
  userType: selectors.userType(state)
});
const connector = connect(mapState);

export default connector(BookingMessageComponent);
